import BasePolicy from '@/policies/BasePolicy.js';

export default class EvaluationTemplatePolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all evaluation templates';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, evaluationTemplate) {
        const permission = 'view a evaluation template';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(evaluationTemplate);
        }

        return user.hasPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a evaluation template';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, evaluationTemplate) {
        const permission = 'edit a evaluation template';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(evaluationTemplate);
        }

        return user.hasPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a evaluation template';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }
}
